import { ANALYTICS_OPENING_HEADER, staffAnalyticsMetricSchema, staffAnalyticsSelectionSchema, staffAnalyticsVisitsSchema, } from "@lafayette/schemas";
import { createMemoryTransport, } from "./memory-transport";
function searchOf(query) {
    const search = new URLSearchParams();
    for (const [key, value] of Object.entries(query ?? {})) {
        if (value !== undefined)
            search.set(key, String(value));
    }
    return search;
}
export function createStaffAnalyticsExploreApi(options) {
    const send = createMemoryTransport(options);
    const base = (customerId) => `/staff/analytics/customers/${encodeURIComponent(customerId)}`;
    return {
        metric: (customerId, openingId, metric, query, callOptions) => send({
            method: "GET",
            path: `${base(customerId)}/metrics/${encodeURIComponent(metric)}`,
            query: searchOf(query),
            headers: { [ANALYTICS_OPENING_HEADER]: openingId },
            schema: staffAnalyticsMetricSchema,
            signal: callOptions?.signal,
        }),
        selection: (customerId, openingId, query, callOptions) => send({
            method: "GET",
            path: `${base(customerId)}/selection`,
            query: searchOf(query),
            headers: { [ANALYTICS_OPENING_HEADER]: openingId },
            schema: staffAnalyticsSelectionSchema,
            signal: callOptions?.signal,
        }),
        visits: (customerId, openingId, query, callOptions) => send({
            method: "GET",
            path: `${base(customerId)}/visits`,
            query: searchOf(query),
            headers: { [ANALYTICS_OPENING_HEADER]: openingId },
            schema: staffAnalyticsVisitsSchema,
            signal: callOptions?.signal,
        }),
    };
}
